export default __webpack_public_path__ + "static/media/igFilter.7fecc770.jpg";